import { render, staticRenderFns } from "./setting-api.vue?vue&type=template&id=54084d96&scoped=true"
import script from "./setting-api.vue?vue&type=script&lang=js"
export * from "./setting-api.vue?vue&type=script&lang=js"
import style0 from "./setting-api.vue?vue&type=style&index=0&id=54084d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54084d96",
  null
  
)

export default component.exports